export default __webpack_public_path__ + "f6e88863001f94c84bf401a0d6d5b248.svg";